"use client";

import React from "react";
import { ReceiptText, Wrench, RefreshCcw } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Tax Efficiency",
  description: "Maximize your business capital with fully deductible leasing payments. Our structured solutions improve your cash flow management while reducing overall tax liability.",
  icon: ReceiptText
}, {
  title: "Full Maintenance",
  description: "Experience worry-free mobility with comprehensive coverage. We handle all servicing, repairs, and tire replacements so your fleet remains reliable and safe on the road.",
  icon: Wrench
}, {
  title: "Total Flexibility",
  description: "Adapt instantly to changing business needs. Enjoy adjustable contract terms, customizable mileage packages, and easy vehicle upgrades whenever you need them.",
  icon: RefreshCcw
}];
export default function LeasingBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="leasing-benefits" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle,hsl(var(--primary)/0.12)_0%,transparent_70%)] blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`mx-auto max-w-2xl text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Why Lease with Ledotravel?
          </h2>
          <p className="text-muted-foreground text-lg">
            Unlock the full potential of your fleet with benefits designed for modern businesses.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          const delay = i * 150;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${delay}ms`
          }}>
                <Card className="bg-card/50 border-border/50 hover:border-primary/50 hover:bg-card/80 group relative h-full overflow-hidden border transition-colors duration-300 backdrop-blur-sm">
                  <CardHeader className="flex flex-col items-center pb-2 text-center">
                    <div className="bg-primary/10 text-primary mb-6 flex h-20 w-20 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110">
                      <Icon className="h-10 w-10 stroke-[1.5]" />
                    </div>
                    <CardTitle className="text-xl font-semibold">{benefit.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="text-muted-foreground text-center leading-relaxed">
                    <CardDescription className="text-base">
                      {benefit.description}
                    </CardDescription>
                  </CardContent>
                  
                  {}
                  <div className="pointer-events-none absolute -inset-px opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.05),transparent_70%)]" />
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}